import { render, staticRenderFns } from "./MutasiDetail.vue?vue&type=template&id=146f62ce&scoped=true"
import script from "./MutasiDetail.vue?vue&type=script&lang=js"
export * from "./MutasiDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146f62ce",
  null
  
)

export default component.exports